import AnimationDelay from '../utils/AnimationDelay';
import swap from '../utils/swap';

const merge = async (a, lo, mid, hi, delayController) => {
  const l = [];
  for (let left = lo, i = lo, right = mid; i < hi; i += 1) {
    if (a[left] < a[right] && left < mid) {
      l.push(a[left]);
      left += 1;
    } else {
      l.push(a[right]);
      right+= 1;
    }
  }
  // console.log(l)
  for (let i = 0; i < hi - lo; i += 1) {
    await delayController.delay();
    a[lo + i] = l[i];
  }
  return new Promise((r) => {
    r()
  })
}
const mergesort = async (a, lo, hi, delayController) => {
  if (lo + 1 < hi) {
    const mid = Math.floor((lo + hi)/2);
    // console.log(`from ${lo} to ${hi}, m: ${mid}`)

    await mergesort(a, lo, mid, delayController);
    await mergesort(a, mid, hi, delayController);
    await merge(a, lo, mid, hi, delayController);
  } else {
    if (a[lo] > a[hi]) {
      const t = a[lo];
      a[lo] = a[hi];
      a[hi] = t;
      await delayController.delay();
    }
  }
  return new Promise((r) => {
    r();
  })
}

export default class MergesortAlgorithm {
  constructor({delayController} = {}) {
    this.delayController = delayController || new AnimationDelay();
  }
  sort (a) {
    mergesort(a, 0, a.length, this.delayController)
  }
}



// WEBPACK FOOTER //
// ./src/algorithms/mergesort.js